import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Flex } from '@decisiv/ui-components';

import { CssResetStyle, MainContainer } from './components/styledComponents';
import Form from './components/Form';
import Success from './components/Success';

import { FORM_SCREEN, SUCCESS_SCREEN } from './constants';

function VendorOnboarding({ dealer, csrfToken, initialScreen }) {
  const [screen, setScreen] = useState(initialScreen);
  const [email, setEmail] = useState('');

  const onSuccessEmailChanged = (newEmail) => {
    setEmail(newEmail);
    setScreen(SUCCESS_SCREEN);
  };

  return (
    <MainContainer>
      <CssResetStyle />

      <Flex justifyContent="center" alignItems="center" flexDirection="column">
        {screen === FORM_SCREEN && (
          <Form
            csrfToken={csrfToken}
            dealer={dealer}
            onSuccessEmailChanged={onSuccessEmailChanged}
          />
        )}

        {screen === SUCCESS_SCREEN && <Success email={email} />}
      </Flex>
    </MainContainer>
  );
}

VendorOnboarding.propTypes = {
  dealer: PropTypes.shape({
    portalName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    owner: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  csrfToken: PropTypes.string.isRequired,
  initialScreen: PropTypes.string,
};
VendorOnboarding.defaultProps = {
  initialScreen: FORM_SCREEN,
};

export default VendorOnboarding;
